<template>
  <app-page wide :title="$t('@employees/title')">
    <v-layout>
      <v-flex xs12>
        <errors-list :errorMessage="errorMessage" />

        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
          :rows-per-page-items="rowsPerPageItems"
          :total-items="pagination.totalItems"
          :pagination.sync="pagination"
        >
          <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
          <template slot="items" slot-scope="props">
            <tr>
              <grid-cell
                :header="header"
                :row="props.item"
                :key="index"
                v-for="(header, index) in headers"
                @action="onAction"
              ></grid-cell>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <v-dialog v-model="modal" persistent lazy full-width width="480px">
      <user-form
        :key="selectedUser && selectedUser.id"
        :userId="selectedUser && selectedUser.id"
        @close-modal="closeModal"
      />
    </v-dialog>
  </app-page>
</template>

<script>
import GridCell from '../../components/GridCell';
import UserForm from './UserForm';
import { serializeQuery } from '../../utils';
import { getErrorMessage } from '../../errorHandlers';
import ErrorsList from '../../components/ErrorsList';

export default {
  components: { GridCell, UserForm, ErrorsList },

  data() {
    return {
      params: { isActive: true },
      date: null,
      items: [],
      selectedUser: null,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 15,
        sortBy: 'fullName',
        totalItems: 0,
      },
      rowsPerPageItems: [10, 15, 50, 100],
      headers: [
        { text: this.$t('@employees/active'), value: 'active', format: (val) => !!val },
        { text: this.$t('@employees/fullName'), value: 'fullName' },
        { text: this.$t('@employees/email'), value: 'email' },
      ],
      modal: false,
      loading: false,
      errorMessage: '',
    };
  },

  watch: {
    pagination() {
      this.fetchData();
    },
  },

  methods: {
    onAction({ action, row }) {
      if (!action) {
        this.selectedUser = row;
        this.modal = true;
      }
    },

    async closeModal(isSent = false) {
      this.modal = false;
      if (isSent) {
        await this.fetchData();
      }
      this.selectedUser = null;
    },

    async updateRoute(query) {
      await this.$router
        .replace({
          name: 'usersList',
          query: { ...this.$route.query, ...query },
        })
        .catch(() => {});
    },

    async fetchData() {
      try {
        this.loading = true;
        const skip = (this.pagination.page - 1) * this.pagination.rowsPerPage;
        const take = this.pagination.rowsPerPage;
        const query = {
          ...this.params,
          skip,
          take,
        };

        if (this.pagination.sortBy) {
          query.sortBy =
            this.pagination.sortBy === 'fullName'
              ? `user.firstName`
              : `user.${this.pagination.sortBy}`;
          query.sortOrder = this.pagination.descending ? 'DESC' : 'ASC';
        } else {
          delete query.sortBy;
          delete query.sortOrder;
        }

        await this.updateRoute(query);

        const queryString = serializeQuery(query);
        const {
          data: {
            data,
            meta: { total },
          },
        } = await this.$http.get(`/api/employees?${queryString}`);
        this.items = data;
        this.pagination.totalItems = total;
        this.errorMessage = '';
      } catch (e) {
        this.errorMessage = getErrorMessage(e);
      } finally {
        this.loading = false;
      }
    },
  },

  created() {
    this.params = { ...this.params, ...this.$router.currentRoute.query };
    this.fetchData();
  },

  beforeRouteUpdate(to, from, next) {
    this.params = { ...this.params, ...to.query };
    next();
  },
};
</script>
